module.exports = __webpack_public_path__ + "static/media/5DPO8.fc28b0f3.jpg";